// ABOUTME: Bottom-anchored modal that hosts the shared TicketDetailPanel for quick ticket triage.
// ABOUTME: Used from the Unassigned tab's stale list so a card click opens chat + details without leaving the page.

import { Box, useTheme } from "@mui/material";
import SHModalBottom from "../../../../../../components/theme/Modal/SHModalBottom";
import { tokens } from "../../../../../../theme";
import TicketDetailPanel from "../TicketDetailPanel";

const MTicketDetailBottom = ({ open, onClose, ticketId, readOnly, viewer }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <SHModalBottom
            open={open}
            onClose={onClose}
            maxWidth={1400}
            sx={{
                body: {
                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                },
            }}
        >
            <Box sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
                {ticketId && (
                    <TicketDetailPanel
                        ticketId={ticketId}
                        readOnly={readOnly}
                        viewer={viewer}
                        // Once the ticket is closed there is nothing left to do
                        // in this sheet — dismiss it along with the ticket.
                        onTicketClosed={onClose}
                    />
                )}
            </Box>
        </SHModalBottom>
    );
};

export default MTicketDetailBottom;
